import API from './API.js'

export default class Departments extends API {
  constructor() {
    super('departments')
  }
}
